import { createAction } from '@reduxjs/toolkit';

export interface SendGraphToExploreAction {
  nodes: {
    id: string;
    x: number;
    y: number;
  }[];
  relationships: string[];
}
export const sendGraphToExplore = createAction('sendGraphToExplore', (queryResult: SendGraphToExploreAction) => ({
  payload: {
    nodes: queryResult.nodes,
    relationships: queryResult.relationships,
  },
}));
